<div *ngIf="data.formType == 'login-erp'">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'question_user_login.title_dialog' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-panel-title class="mat-panel-title">
  
  </mat-panel-title>
  <div class="pb-3">
    <p>{{'question_user_login.question_login' | translate}}</p>
  </div>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <div class="mt-2">
      <button mat-stroked-button color="primary" (click)="onNoClick()" type="button">
        <mat-icon>cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
    </div>
    <div class="pl-3 pt-2">
      <button type="button" mat-raised-button color="primary" (click)="onDoneClick()">
        <mat-icon>done</mat-icon>
        {{'button.accept' | translate}}
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.formType == 'login-erp-error'">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'question_token_login_error.title_dialog' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-panel-title class="mat-panel-title">
  
  </mat-panel-title>
  <div class="pb-3">
    <p>{{'question_token_login_error.question_login' | translate}}</p>
  </div>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <div class="pl-3 pt-2">
      <button type="button" mat-raised-button color="primary" (click)="onDoneClick()">
        <mat-icon>done</mat-icon>
        {{'button.accept' | translate}}
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.formType == 'login-token-invalid'">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'question_token_login_invalid.title_dialog' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-panel-title class="mat-panel-title">
  
  </mat-panel-title>
  <div class="pb-3">
    <p>{{'question_token_login_invalid.question_login' | translate}}</p>
  </div>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <div class="pl-3 pt-2">
      <button type="button" mat-raised-button color="primary" (click)="onDoneClick()">
        <mat-icon>done</mat-icon>
        {{'button.accept' | translate}}
      </button>
    </div>
  </div>
</div>

<div *ngIf="data.formType == 'login-token-error-home'">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'question_token_login_home.title_dialog' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-panel-title class="mat-panel-title">
  
  </mat-panel-title>
  <div class="pb-3">
    <p>{{'question_token_login_home.question_login' | translate}}</p>
  </div>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <div class="pl-3 pt-2">
      <button type="button" mat-raised-button color="primary" (click)="onDoneClick()">
        <mat-icon>done</mat-icon>
        {{'button.accept' | translate}}
      </button>
    </div>
  </div>
</div>


<div *ngIf="data.formType == 'login-token-locked'">
  <h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'question_token_login_token_locked.title_dialog' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-panel-title class="mat-panel-title">

  </mat-panel-title>
  <div class="pb-3">
    <p>{{'question_token_login_token_locked.question_login' | translate}}</p>
  </div>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <div class="pl-3 pt-2">
      <button type="button" mat-raised-button color="primary" (click)="onDoneClick()">
        <mat-icon>done</mat-icon>
        {{'button.accept' | translate}}
      </button>
    </div>
  </div>
</div>
